interface DosingTitleProps {
  title: string;
  subtitle?: string;
}

const DosingTitle = ({ title, subtitle }: DosingTitleProps) => {
  return (
    <div className="my-2 d-flex flex-column align-items-center">
      <div className="fw-bold text-purple text-center w-100 mb-2">{title}</div>
      {subtitle && <div className="fw-bold text-center text-md-start w-100 ">{subtitle}</div>}
    </div>
  );
};

export default DosingTitle;
